import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrfToken;
axios.defaults.headers.common['Authorization'] = "Bearer " + window.apiToken;

if (!window.baseURL) {
    console.error('No Base URL set. Using base.');
}

const instance = axios.create({
    baseURL: window.baseURL || '/api/v1/',
    timeout: 1000000,
});

export const webInstance = axios.create({
    timeout: 25000
});

export default instance;
